import type { KlevuSearchSorting } from "@klevu/core";

export type SearchResultProduct = {
	id: string;
	name: string;
	url: string;
	image: string;
	currency: string;
	price: string;
	sku: string;
	color: string;
	fabric?: string;
	imageHover: string;
};

export type SearchResultCMS = {
	id: string;
	name: string;
	url: string;
	shortDesc?: string;
	image: string;
	alt?: string;
};

export type SearchConfiguration = {
	type: "product" | "page";
};

export type UseSearchParams = {
	searchTerm?: string;
	searchType?: SearchConfiguration["type"];
	limit?: number;
};

export type UseSearch = {
	search: (
		searchTerm: string,
		selectedFilter: SelectedFilter | undefined,
		configuration: SearchConfiguration,
		sortTerm?: KlevuSearchSorting,
	) => void;
	showMoreProducts: () => void;
	showMorePages: () => void;
	clear: () => void;
	removeFilter: (filter: Filter) => void;
	productResults: SearchResultProduct[];
	cmsResults: SearchResultCMS[];
	sortTerm: KlevuSearchSorting;
	filters: Filter[];
	loading: boolean;
	error: boolean;
	query: string;
	hasNextPage: boolean;
	isQuickSearch?: boolean;
	suggestionResults: { suggest: string }[];
};

export type OptionsProps = {
	name: string;
	value?: string;
	sort?: KlevuSearchSorting;
	selected?: boolean;
	hexOne?: string;
	hexTwo?: string;
	multiColored?: boolean;
};

export type Filter = {
	key: string;
	label: string;
	translatedLabel: string;
	options: OptionsProps[];
	type: FilterType;
};

export type SelectedFilter = {
	key: string;
	label: string;
	option: OptionsProps;
};

export enum FilterType {
	sort = "Sort",
	dynamic = "Dynamic",
}
